import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {PagedData} from "./users/datatable/paged-data";
import {usersDataTable} from "./users/datatable/usersDataTable";
import {Page} from "./users/datatable/page";
/**
 * A server used to mock a paged data result from a server
 */
@Injectable()
export class usersResultService {
    listData:any;
    rawData:any;
    api_credential= {};
    loginData;
    rows = {};
    dashboardData = {};

    constructor(){
    }


    /**
     * A method that mocks a paged server response
     * @param page The selected page
     * @returns {any} An observable containing the employee data
     */
    public getResults(page: Page,listData): Observable<PagedData<usersDataTable>> {
            this.listData = listData;
            return Observable.of(listData).map(data => this.getPagedData(page));
    }

    /**
     * Package companyData into a PagedData object based on the selected Page
     * @param page The page data used to get the selected data from companyData
     * @returns {PagedData<icsList>} An array of the selected data and page
     */
    private getPagedData(page: Page): PagedData<usersDataTable> {
        let pagedData = new PagedData<usersDataTable>();
        let offset = this.listData.offSet;
        let raw = [];
        for(let l in this.listData){
            if(Object.keys(this.listData[l]).length > 0){
                raw[offset+parseInt(l)] = this.listData[l];
            }
        }
        if(this.listData.total_count){
            page.totalElements = this.listData.total_count;
        }
        page.totalPages = page.totalElements / page.size;
        let start = page.pageNumber * page.size;
        let end = Math.min((start + page.size), page.totalElements);
        for (let i = start; i < end; i++) {
            if(raw[i]){
                let jsonObj = raw[i];
                if(jsonObj){
                     let list = new usersDataTable(jsonObj['firstName'],jsonObj['lastName'],jsonObj['email'],
                     jsonObj['region'],jsonObj['country'],jsonObj['role'],jsonObj['id']);
                       pagedData.data.push(list);
                }
            }
        }
        pagedData.page = page;
        return pagedData;
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/usersResultService.ts